import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { useEffect, useState } from 'react';
import { useOrganizations } from '@vivli/features/organizations/infrastructure/hook';
import { BulkUploadStudiesFormComponent } from '@vivli/features/studies/components';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';
import {
    useActiveUserContext,
    useAssignedAppTypeContext,
    useModalApiContext,
    useOrganizationsApiContext
} from '@vivli/core/infrastructure/context';
import { first } from 'rxjs/operators';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { FormProvider } from 'react-hook-form';
import { useBulkUploadFormHook } from '@vivli/features/studies/infrastructure/hook';

export const BulkUploadStudiesFeature = () => {
    const formApi = useBulkUploadFormHook();
    const { user, orgHasPermission } = useActiveUserContext();
    const { organizations } = useOrganizations();
    const organizationService = useOrganizationsApiContext();
    const modalService = useModalApiContext();
    const { isAmr } = useAssignedAppTypeContext();
    const [currentOrg, setCurrentOrg] = useState<IOrganization>(null);
    const [bulkUploadId, setBulkUploadId] = useState<string>(null);
    //TODO PERMFE - redo with permissions+
    let myOrganizations = user?.orgMemberships.filter((om) => orgHasPermission(om.orgId, PermissionsEnum.DataContrib)) || [];
    if (myOrganizations.length === 0) {
        myOrganizations = user?.orgMemberships.filter((om) => orgHasPermission(om.orgId, PermissionsEnum.ProviderActAdv));
    }

    const getDraftUpdateId = () => {
        organizationService
            .getDraftBulkUploadId(currentOrg?.id, isAmr)
            .pipe(first())
            .subscribe(
                (id) => {
                    setBulkUploadId(id);
                },
                (error) => modalService.error(error)
            );
    };

    useEffect(() => {
        if (!organizations) {
            return;
        }

        const [myOrgRole] = myOrganizations;
        setCurrentOrg(organizations?.find((o) => o.id === myOrgRole?.orgId));
    }, [organizations]);

    useEffect(() => {
        getDraftUpdateId();
    }, [currentOrg]);

    if (!organizations) {
        return <LoadIndicatorCenteredView />;
    }

    return (
        <FormProvider {...formApi}>
            <BulkUploadStudiesFormComponent bulkUploadId={bulkUploadId} />
        </FormProvider>
    );
};
